import React from 'react';
import { Modal } from 'react-bootstrap';
import PropTypes from 'prop-types';

import Form from './Form';

export default function Popup({ invoiceId, show, onHide }) {
  return (
    <Modal
      className="student inmodal auto without-overflow"
      show={show}
      onHide={onHide}
    >
      <Modal.Header closeButton>
        <Modal.Title>
          Cancel Invoice
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form invoiceId={invoiceId} onHide={onHide} />
      </Modal.Body>
    </Modal>
  );
}

Popup.propTypes = {
  invoiceId: PropTypes.number.isRequired,
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
};
